<template>
  <BaseModal ref="base" name="removeParceiroModal" centered>
    <template #title>
      Remover parceiro
    </template>
    <template #body>
      Deseja remover o parceiro <b class="text-break">{{ nome }}</b>?
    </template>
    <template #footer>
      <LoadingButton type="button" class="btn-danger" :loading="loading" @click="remove">
        <i class="bi bi-trash" /> Excluir
      </LoadingButton>
      <button type="button" class="btn btn-secondary" @click="hide">
        <i class="bi bi-x" /> Cancelar
      </button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/modules/core/components/BaseModal.vue';
import LoadingButton from '@/modules/core/components/LoadingButton.vue';
import { deleteParceiro } from '../parceiroService';
import { useToast } from 'vue-toastification';

export default {
  components: { BaseModal, LoadingButton },
  props: {
    id: { type: String, required: true },
    nome: { type: String, required: true },
  },
  emits: ['update-table'],
  data: () => ({ loading: false }),
  methods: {
    show() { this.$refs.base.show(); },
    hide() { this.$refs.base.hide(); },
    async remove() {
      this.loading = true;
      try {
        if (await deleteParceiro(this.id)) {
          this.$emit('update-table');
          useToast().success(`O parceiro '${this.nome}' foi removido com sucesso.`);
        } else {
          useToast().error(`O parceiro '${this.nome}' não foi encontrado ou já foi removido.`);
        }
        this.$refs.base.hide();
      } catch (error) {
        useToast().error('Erro de conexão');
      }
      this.loading = false;
    },
  },
};
</script>
